import { render, staticRenderFns } from "./batchOrder.vue?vue&type=template&id=aaeb0fb8&scoped=true&"
import script from "./batchOrder.vue?vue&type=script&lang=js&"
export * from "./batchOrder.vue?vue&type=script&lang=js&"
import style0 from "./batchOrder.vue?vue&type=style&index=0&id=aaeb0fb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaeb0fb8",
  null
  
)

export default component.exports